import {ELECTRICITY, METER_CATEGORY} from 'constants/enum/meterType'
import {CONSTANT, NAME_RATE} from 'constants/enum/nameRate'
import {TYPE_DAY} from 'constants/enum/rateType'
import ZodConfig from 'constants/zodConfig'
import {z} from 'zod'
import isNil from 'lodash/isNil'
const name = {
    name: 'name',
    type: 'select',
    label: 'name',
    options: NAME_RATE,
    withTranslation: true,
    rules: {required: true},
    sm: 6,
    xs: 12,
}

const rate = {
    name: 'rate',
    type: 'number',
    rules: {required: true},
    sm: 6,
    xs: 12,
}

const monthStart = {
    name: 'monthStart',
    type: 'number',
    rules: {required: true},
    sm: 6,
    xs: 6,
}

const monthEnd = {
    name: 'monthEnd',
    type: 'number',
    rules: {required: true},
    sm: 6,
    xs: 6,
}

const hourStart = {
    name: 'hourStart',
    type: 'number',
    rules: {required: true},
    sm: 6,
    xs: 6,
}

const hourEnd = {
    name: 'hourEnd',
    type: 'number',
    rules: {required: true},
    sm: 6,
    xs: 6,
}

const typeDay = {
    name: 'typeDay',
    type: 'select',
    options: TYPE_DAY,
    withTranslation: true,
    rules: {required: true},
    xs: 12,
}

const status = {
    name: 'status',
    type: 'switch',
    sm: 12,
}

const category = {
    name: 'category',
    type: 'select',
    options: METER_CATEGORY,
    rules: {required: true},
    withTranslation: true,
    sm: 6,
    xs: 12,
}

const isGlobal = {
    name: 'isGlobal',
    type: 'checkbox',
    sm: 6,
}

const rateSection = {
    title: 'rateSection',
    items: {
        status,
        category,
        name,
        rate,
    },
}

const settingSection = {
    title: 'settings',
    items: {
        isGlobal,
    },
}

const dateAndTimeSection = {
    title: 'dateAndTimeSection',
    hidden: true,
    items: {
        typeDay,
        hourStart,
        hourEnd,
        monthStart,
        monthEnd,
    },
}

export const createRateField = {
    settingSection,
    rateSection,
    dateAndTimeSection,
}

export const createRateFieldValidation = z.object({
    name: ZodConfig.string(),
    rate: ZodConfig.number({min: 0}),
    monthStart: ZodConfig.number({min: 1, max: 12}).optional(),
    monthEnd: ZodConfig.number({min: 1, max: 12}).optional(),
    hourStart: ZodConfig.number({min: 0, max: 23}).optional(),
    hourEnd: ZodConfig.number({min: 0, max: 23}).optional(),
    hours: ZodConfig.array(ZodConfig.number({min: 0, max: 23})).optional(),
    months: ZodConfig.array(ZodConfig.number({min: 1, max: 12})).optional(),
    typeDay: ZodConfig.enum(TYPE_DAY).optional(),
    category: ZodConfig.enum(METER_CATEGORY),
    status: ZodConfig.boolean().optional(),
    isGlobal: ZodConfig.boolean().optional(),
})

export const rateValidationSchemaSuperRefine = (data, ctx) => {
    if (data.category === ELECTRICITY && data.name !== CONSTANT) {
        if (isNil(data.typeDay)) {
            ctx.addIssue({
                path: ['typeDay'],
                code: z.ZodIssueCode.custom,
                message: 'Required',
            })
        }
        // if (isNil(data.monthStart) && !data.months) {
        //     ctx.addIssue({
        //         path: ['monthStart'],
        //         code: z.ZodIssueCode.custom,
        //         message: 'Required',
        //     })
        // }
        // if (isNil(data.monthEnd) && !data.months) {
        //     ctx.addIssue({
        //         path: ['monthEnd'],
        //         code: z.ZodIssueCode.custom,
        //         message: 'Required',
        //     })
        // }
        // if (isNil(data.hourStart) && !data.hours) {
        //     ctx.addIssue({
        //         path: ['hourStart'],
        //         code: z.ZodIssueCode.custom,
        //         message: 'Required',
        //     })
        // }
        // if (isNil(data.hourEnd) && !data.hours) {
        //     ctx.addIssue({
        //         path: ['hourEnd'],
        //         code: z.ZodIssueCode.custom,
        //         message: 'Required',
        //     })
        // }
    }
    if (data.isGlobal) {
        data.account = null
    }
    if (!data.isGlobal && !data.account) {
        ctx.addIssue({
            path: ['account'],
            code: z.ZodIssueCode.custom,
            message: 'Required',
        })
        ctx.addIssue({
            path: ['isGlobal'],
            code: z.ZodIssueCode.custom,
            message: 'Required',
        })
    }
}
